import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import Vuex from "vuex";
import * as API from "../api/global";
import i18n from "@/locales/i18n.js";
Vue.use(VueRouter)

export const _CONSTANTS_ROUTERS =
    [
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/login/login.vue'),
            meta:{title:i18n.t('login_logOn')}
        },
        {
            path: '/getpassword',
            name: 'getpassword',
            component: () => import('../views/getpassword/index.vue'),
            meta:{title:i18n.t('getpassword_title')}
        }

    ];
export const createRouter = routes => new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const router =new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: _CONSTANTS_ROUTERS
});


router.beforeEach((to,from,next)=>{
    if (to.path=='/login') return next()
    if (to.path=='/getpassword') return next()
    const tokenStr=window.sessionStorage.getItem('token')
    if(!tokenStr){
        next("/login")
    }else {
        if (_CONSTANTS_ROUTERS.length<3){
            addRouteList();
        }

    }
    next();
})
function addRouteList() {
    let param = {
        i_uid: sessionStorage.getItem('userid'),
        token: sessionStorage.getItem('token'),
        app: 'masterdata',
        version: "1.0"
    };

    API.getMenuoperation(param).then(
        res=>{
            let data=routesData(res.menuList);
            router.matcher = createRouter().matcher;
            router.addRoutes(data)

        }
    )
}
function routesData(result) {
    let redirectPath='';
    let newArray=[];
    let array=fun(result);
    let title=i18n.t('menu_index');
    // console.log(title,'title')
    array.push(
        { path: '/home/desk.vue',
            name: 'home/desk.vue',
            component: () => import('../views/home/desk.vue'),
            meta:{title: title}

        }
    )

    _CONSTANTS_ROUTERS.push({
        path: '/',
        name: 'index',
        component: Index,
        // redirect: "./Home.vue",
        children:array
    })
    // console.log(_CONSTANTS_ROUTERS)
    return _CONSTANTS_ROUTERS
}
function fun(arr) {
    let res=[];
    // console.log(arr,"arr");
    if (arr.length>0){
        arr.forEach(item => {
            let newItem = {}
            // console.log(item,"item")
            if (item.i_id) {
                newItem= {
                    // path: first(item.vc_url,item.smenuList),
                    // name: first(item.vc_url,item.smenuList),
                    path: item.vc_url,
                    name: item.vc_url,
                    component: () => import(`@/views${item.vc_url}`),
                    meta:{
                        title: item.vc_name,
                        mid:item.i_id
                    },
                }
                // console.log(`@/views${item.vc_url}`)
            }
            if (item.smenuList && item.smenuList.length>0) {
                // newItem.children = fun(item.smenuList)
                res =res.concat(fun(item.smenuList))
            }else{
                res.push(newItem)
            }
        })
    }
    return res
}
function first(url,smenuList) {
    let name=''
    if (smenuList&& smenuList.length>0){
        let m=url.lastIndexOf(".");
        if(m!=-1){
            let index=url.lastIndexOf("/");
            let before=url.slice(0,index);
            let j=before.lastIndexOf("/");
            name=before.slice(j+1);
        }else{
            let index=url.lastIndexOf("/");
            let before=url.slice(index+1);
            let j=before.lastIndexOf("/");
            name=before;
        }

        // console.log("url",before)
    }else{
        let index=url.lastIndexOf("/");
        let before=url.slice(0,index);
        let i=before.lastIndexOf("/");
        name=url.slice(i+1);
    }

    // console.log("url",name)
    return name

}
export default router
